import React, { Component } from 'react';
import "./Resume.css";

class Skills extends Component {
    render() {
        return (
            <div className="skills">
                <h1 className="text-center section-heading">Skills</h1>
                <hr/>
                <p className="text-center skills-p">&#8226;HTML5  &#8226;CSS 3   &#8226;Javascript - ES5 and ES6   &#8226; jQuery</p>
                <p className="text-center skills-p">&#8226;Bootstrap 4.0   &#8226; React.js   &#8226;Redux   &#8226;Handlebars   &#8226;SendGrid</p>
                <p className="text-center skills-p">&#8226;MySQL   &#8226;Sequelize   &#8226;Mongo   &#8226;Mongoose</p>
                <p className="text-center skills-p">&#8226;Object Oriented Programming   &#8226;Software Testing Methodology</p>
                <p className="text-center skills-p">&#8226;C++   &#8226;C   &#8226;Embedded Programming</p>
                <p className="text-center skills-p">&#8226;Linux   &#8226;Open Source Software</p>
            </div>
        );
    }
}

export default Skills;




// WEBPACK FOOTER //
// ./src/components/Resume/Skills.js